
const digest = '0b1cfbd28c8edd91537152a6d2e16e3edcc5341a83a2abf525ebf1673a168348';
const classes = {"item":"_item_1blmq_1","checkboxWrapper":"_checkboxWrapper_1blmq_13","cross":"_cross_1blmq_19","image":"_image_1blmq_22","name":"_name_1blmq_29","birthNumber":"_birthNumber_1blmq_34","badgeWrapper":"_badgeWrapper_1blmq_38","badges":"_badges_1blmq_46"};
const css = `._item_1blmq_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #aeb8cb;
  padding: 24px;
  align-items: center;
  cursor: pointer;
  position: relative;
  background-color: #ffffff;
  border-radius: 10px;
}
._item_1blmq_1 ._checkboxWrapper_1blmq_13 {
  position: absolute;
  top: 6px;
  right: 6px;
  z-index: 1;
}
._item_1blmq_1 ._cross_1blmq_19 {
  height: 15px;
}
._item_1blmq_1 ._image_1blmq_22 img {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  margin-bottom: 15px;
  object-fit: cover;
}
._item_1blmq_1 ._name_1blmq_29 {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}
._item_1blmq_1 ._birthNumber_1blmq_34 {
  font-size: 14px;
  color: #787c88;
}
._item_1blmq_1 ._badgeWrapper_1blmq_38 {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
._item_1blmq_1 ._badges_1blmq_46 {
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  